export default __webpack_public_path__ + "static/media/page-layout.7425a36b.svg";